import { useState, useEffect } from 'react'
import { countPending } from '../lib/offlineDB'

export function useOnlineStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine)
  const [pendingCount, setPendingCount] = useState(0)

  useEffect(() => {
    const update = () => {
      setIsOnline(navigator.onLine)
      countPending().then(setPendingCount).catch(() => setPendingCount(0))
    }

    window.addEventListener('online', update)
    window.addEventListener('offline', update)

    // Also update when sync completes
    const syncHandler = () => {
      countPending().then(setPendingCount).catch(() => setPendingCount(0))
    }
    window.addEventListener('palstro-sync-complete', syncHandler)

    // Initial count
    countPending().then(setPendingCount).catch(() => setPendingCount(0))

    return () => {
      window.removeEventListener('online', update)
      window.removeEventListener('offline', update)
      window.removeEventListener('palstro-sync-complete', syncHandler)
    }
  }, [])

  return { isOnline, pendingCount }
}
